/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'automation-menu.empty-state.image.alt': 'Ikon for en tom automatiseringsliste',
  'automation-menu.empty-state.learn-more.link': 'Finn ut mer om den manuelle utløseren',
  'automation-menu.modal.empty.automations.admin.description':
    'Bruk den manuelle utløseren for å fylle ut en meny med valg som alle, eller personene du velger, kan bruke som automatiseringer på ett klikk.',
  'automation-menu.modal.empty.automations.user.description':
    'Administratorene har ikke konfigurert noen manuelt utløste automatiseringer ennå.',
  'automation-menu.modal.error.description': 'Dette tar litt tid å laste inn. Prøv å oppdatere siden.',
  'automation-menu.modal.error.image.alt': 'Feil-ikon',
  'automation-menu.modal.footer.automate-button': 'Automatiser',
  'automation-menu.modal.footer.cancel-button': 'Avbryt',
  'automation-menu.modal.footer.get-started-button': 'Opprett automatisering',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': 'Ikon for overskrift for automatiseringsmodal',
  'automation-menu.success-state.message': 'Automatiseringen din pågår',
  'fabric.linking.access_exists_description': 'Be om tilgang for å vise dette innholdet fra {hostname}.',
  'fabric.linking.actions': 'Tiltak',
  'fabric.linking.add_account': 'Legg til en konto',
  'fabric.linking.ai_summarize': 'Oppsummer',
  'fabric.linking.ai_summarized': 'Oppsummert av Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Oppsummert av AI',
  'fabric.linking.ai_summarized_info': 'Kvaliteten på informasjonen kan variere. <a>Finn ut mer</a>',
  'fabric.linking.ai_summarized_info_short': 'Kvaliteten på innholdet kan variere',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence arbeider …',
  'fabric.linking.ai_summary_action': 'Oppsummer med AI',
  'fabric.linking.ai_summary_action_description':
    'Oppsummer innholdet i denne koblingen ved hjelp av Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Vi kan ikke vise resultatene av dette sammendraget fordi det strider mot <a>Atlassians retningslinjer for akseptabel bruk</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence kan ikke generere et sammendrag for deg akkurat nå fordi det er for mye innhold å oppsummere.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) svarer ikke. Prøv igjen senere eller <a>sjekk AI-statusen</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence kan ikke behandle forespørselen din ettersom innholdet ditt inneholder koblinger til HIPAA-begrenset innhold.',
  'fabric.linking.assigned_to': 'Tilordnet til {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Bruk en automatisering på <b>{name}</b>.{br}De tilgjengelige valgene styres av Confluence- og områdeadministratorer.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Sideautomatiseringer',
  'fabric.linking.automation-action.icon.label': 'Automatiseringsikon',
  'fabric.linking.automation-action.title': 'Vis automatiseringsregler',
  'fabric.linking.automation-action.tooltip': 'Velg automatiseringsregelen du vil kjøre',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Avbryt',
  'fabric.linking.cannot_connect': 'Kan ikke koble til, prøv på nytt',
  'fabric.linking.cannot_find_link': 'Finner ikke koblingen',
  'fabric.linking.check_this_link': 'Sjekk denne koblingen',
  'fabric.linking.click_to_join': 'Bli med i {context}',
  'fabric.linking.click_to_join_description': 'Du er blitt godkjent, så du kan bli med i {context} med én gang.',
  'fabric.linking.close': 'Lukk',
  'fabric.linking.connect_account_description':
    'Vi vil åpne en ny side for å hjelpe deg med å koble til {name}-kontoen din',
  'fabric.linking.connect_link_account': 'Koble til for forhåndsvisning',
  'fabric.linking.connect_link_account_card_view': 'Koble til',
  'fabric.linking.connect_link_account_card_view_description':
    'For en forhåndsvisning av denne koblingen kobler du til {context}-kontoen din.',
  'fabric.linking.connect_link_account_card_view_name': 'Koble til {context}-kontoen din',
  'fabric.linking.connect_to': 'Koble til {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Koble til {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Koble til {context}-kontoen din for å samarbeide mellom flere Atlassian-produkter.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Koble til kontoen din for å samarbeide mellom flere Atlassian-produkter.',
  'fabric.linking.continue': 'Fortsett',
  'fabric.linking.copied_summary_action_description': 'Sammendraget er kopiert til utklippstavlen',
  'fabric.linking.copied_url_to_clipboard': 'Kopiert!',
  'fabric.linking.copy_summary_action': 'Kopier sammendrag',
  'fabric.linking.copy_summary_action_description': 'Kopier sammendrag',
  'fabric.linking.copy_url_to_clipboard': 'Kopier kobling',
  'fabric.linking.couldnt_load_link': 'Vi kan ikke laste inn denne koblingen av ukjent grunn.',
  'fabric.linking.create_on_absolute': 'Opprettet {context}',
  'fabric.linking.create_on_relative': 'Opprettet {context}',
  'fabric.linking.created_by': 'Opprettet av {context}',
  'fabric.linking.delete': 'Slett',
  'fabric.linking.direct_access': 'Bli med nå',
  'fabric.linking.direct_access_description':
    'Teamet ditt bruker {product} til å samarbeide, og du kan begynne å bruke det med en gang!',
  'fabric.linking.direct_access_title': 'Bli med i {product} for å se dette innholdet',
  'fabric.linking.download': 'Last ned',
  'fabric.linking.download_description': 'Last ned denne filen til lokal lagring',
  'fabric.linking.download_file': 'Last ned fil',
  'fabric.linking.edit': 'Rediger',
  'fabric.linking.follow': 'Følg',
  'fabric.linking.follow_goal': 'Følg mål',
  'fabric.linking.follow_goal_description': 'Følg dette målet for å få varsler om oppdateringer',
  'fabric.linking.follow_goal_error':
    'Det oppstod en feil da vi prøvde å følge målet. Sjekk nettverkstilkoblingen din, eller oppdater siden og prøv på nytt.',
  'fabric.linking.follow_project': 'Følg prosjekt',
  'fabric.linking.follow_project_description': 'Følg for å få varsler om dette prosjektet',
  'fabric.linking.follow_project_error':
    'Det oppstod en feil da vi prøvde å følge prosjektet. Sjekk nettverkstilkoblingen din, eller oppdater siden og prøv på nytt.',
  'fabric.linking.forbidden_access': 'Du har ikke tilgang',
  'fabric.linking.forbidden_description': 'Kontakt administratoren for å be om tilgang til {hostname}.',
  'fabric.linking.forbidden_title': 'Du har ikke tilgang til dette innholdet',
  'fabric.linking.generic_error_message': 'Det oppstod en feil',
  'fabric.linking.go_back': 'Gå tilbake',
  'fabric.linking.invalid_permissions': 'Begrenset innhold',
  'fabric.linking.invalid_permissions_description':
    'Du må be om tilgang eller prøve en annen konto for kunne se denne forhåndsvisningen.',
  'fabric.linking.join_to_view': 'Bli med {context} for å se denne saken',
  'fabric.linking.join_to_view-issue-term-refresh': 'Slutt deg til {context} for å se denne arbeidsoppgaven',
  'fabric.linking.learn_more_about_connecting_account': 'Finn ut mer om å koble kontoen din til Atlassian-produkter.',
  'fabric.linking.learn_more_about_smart_links': 'Finn ut mer om smartkoblinger.',
  'fabric.linking.link_safety_warning_message':
    '{unsafeLinkText}-koblingen tar deg til et annet nettsted, <a>actual link here</a>',
  'fabric.linking.loading': 'Laster …',
  'fabric.linking.modified_on_absolute': 'Oppdatert {context}',
  'fabric.linking.modified_on_relative': 'Oppdatert {context}',
  'fabric.linking.more_actions': 'Flere handlinger',
  'fabric.linking.more_information_about_this_work_item': 'Mer informasjon om denne arbeidsoppgaven',
  'fabric.linking.no_access_title': 'Bli med i {product} for å se dette innholdet',
  'fabric.linking.not_found_description':
    'Siden finnes ikke, eller den kan ha blitt endret siden denne koblingen ble lagt til.',
  'fabric.linking.not_found_title': 'Vi kan ikke vise deg denne {product}-siden',
  'fabric.linking.open_issue_in_jira': 'Åpne saken i Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Åpne arbeidsoppgaven i Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Åpne kobling i en ny fane',
  'fabric.linking.owned_by': 'Eid av {context}',
  'fabric.linking.pending_request': 'Avventer svar på forespørselen din om tilgang',
  'fabric.linking.preview_close': 'Lukk forhåndsvisning',
  'fabric.linking.preview_description': 'Åpne en forhåndsvisning av denne koblingen i fullskjerm',
  'fabric.linking.preview_improved': 'Åpne forhåndsvisning',
  'fabric.linking.preview_max_size': 'Vis fullskjerm',
  'fabric.linking.preview_min_size': 'Lukk fullskjerm',
  'fabric.linking.priority_blocker': 'Blokkering',
  'fabric.linking.priority_critical': 'Kritisk',
  'fabric.linking.priority_high': 'Høy',
  'fabric.linking.priority_highest': 'Høyest',
  'fabric.linking.priority_low': 'Lav',
  'fabric.linking.priority_lowest': 'Lavest',
  'fabric.linking.priority_major': 'Alvorlig',
  'fabric.linking.priority_medium': 'Middels',
  'fabric.linking.priority_minor': 'Mindre alvorlig',
  'fabric.linking.priority_trivial': 'Uviktig',
  'fabric.linking.priority_undefined': 'Udefinert',
  'fabric.linking.read_time': '{context} min å lese',
  'fabric.linking.related': 'Beslektet',
  'fabric.linking.related_links_found_in': 'Funnet i',
  'fabric.linking.related_links_found_in_v2': 'Funnet i',
  'fabric.linking.related_links_includes_links_to': 'Inkluderer koblinger til',
  'fabric.linking.related_links_includes_links_to_v2': 'Inkluderer koblinger til',
  'fabric.linking.related_links_modal_error_description':
    'Sjekk nettverkstilkoblingen, eller oppdater siden for å prøve på nytt',
  'fabric.linking.related_links_modal_error_header': 'Det oppstod en feil',
  'fabric.linking.related_links_modal_error_message':
    'Det oppstod et problem under innlasting av nylige koblinger. Sjekk tilkoblingen eller oppdater for å prøve igjen.',
  'fabric.linking.related_links_modal_error_title': 'Vi har problemer med å laste relaterte koblinger',
  'fabric.linking.related_links_modal_title': 'Nylige koblinger',
  'fabric.linking.related_links_modal_title_v2': 'Relaterte koblinger',
  'fabric.linking.related_links_modal_unavailable_description':
    'Vi gjennomgår og legger stadig til relaterte koblinger for oppdaterte sider eller andre innholdstyper',
  'fabric.linking.related_links_modal_unavailable_header': 'Ingen nylige koblinger',
  'fabric.linking.related_links_modal_unavailable_message':
    'Vi finner ingen koblinger å vise her. Vi gjennomgår og legger stadig til nylige koblinger for oppdaterte sider eller andre innholdstyper.',
  'fabric.linking.related_links_modal_unavailable_title': 'Vi finner ingen relaterte koblinger',
  'fabric.linking.related_links_not_found': 'Vi finner ingen koblinger å vise her.',
  'fabric.linking.related_links_view_related_links': 'Vis relaterte koblinger',
  'fabric.linking.related_links_view_related_urls': 'Vis nylige koblinger',
  'fabric.linking.request_access': 'Be om tilgang',
  'fabric.linking.request_access_description':
    'Teamet ditt bruker {product} til å samarbeide. Be administratoren din om tilgang.',
  'fabric.linking.request_access_pending': 'Venter på godkjenning',
  'fabric.linking.request_access_pending_description':
    'Forespørselen din om tilgang til {hostname} venter på godkjenning fra administratoren.',
  'fabric.linking.request_access_pending_title': 'Venter på tilgang til {product}',
  'fabric.linking.request_access_to_view': 'Be om tilgang til {context} for å vise denne saken',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'Be om tilgang til {context} for å vise denne arbeidsoppgaven',
  'fabric.linking.request_denied': 'Forespørselen din om tilgang ble avslått',
  'fabric.linking.request_denied_description':
    'Administratoren godkjente ikke forespørselen din om å vise {product}-sider fra {hostname}.',
  'fabric.linking.restricted_link': 'Begrenset kobling, prøv en annen konto',
  'fabric.linking.retry': 'Prøv igjen',
  'fabric.linking.save': 'Lagre',
  'fabric.linking.sent_on_absolute': 'Sendt {context}',
  'fabric.linking.sent_on_relative': 'Sendt {context}',
  'fabric.linking.srclink': 'Se i',
  'fabric.linking.srclinkunknown': 'Vis original',
  'fabric.linking.status_change_load_error': 'Vi kan ikke laste inn statuser og overføringer',
  'fabric.linking.status_change_permission_error': 'Du har ikke tillatelse til å overføre denne saken.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Du har ikke tillatelse til å overføre denne arbeidsoppgaven.',
  'fabric.linking.status_change_update_error': 'Vi kan ikke oppdatere statusen',
  'fabric.linking.try_again': 'Prøv på nytt',
  'fabric.linking.try_another_account': 'Prøv en annen konto',
  'fabric.linking.unassigned': 'Ikke tilordnet',
  'fabric.linking.unauthorised_account_description':
    'Du prøver å forhåndsvise en kobling til en privat {context}-side. Vi anbefaler at du sjekker nettadressen eller kontakter sideeieren.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Du prøver å forhåndsvise en kobling til en privat side. Vi anbefaler at du sjekker nettadressen eller kontakter sideeieren.',
  'fabric.linking.unauthorised_account_name': 'Vi kan ikke vise private sider fra {context}',
  'fabric.linking.unauthorised_account_name_no_provider': 'Vi kan ikke vise private sider',
  'fabric.linking.unfollow': 'Slutt å følge',
  'fabric.linking.unfollow_goal': 'Slutt å følge mål',
  'fabric.linking.unfollow_goal_description': 'Slutt å følge for å slutte å motta varsler for dette målet',
  'fabric.linking.unfollow_goal_error':
    'Det oppstod en feil da vi prøvde å slutte å følge målet. Sjekk nettverkstilkoblingen din, eller oppdater siden og prøv på nytt.',
  'fabric.linking.unfollow_project': 'Slutt å følge prosjekt',
  'fabric.linking.unfollow_project_description': 'Slutt å følge for å slutte å motta prosjektvarsler',
  'fabric.linking.unfollow_project_error':
    'Det oppstod en feil da vi prøvde å slutte å følge prosjektet. Sjekk nettverkstilkoblingen din, eller oppdater siden og prøv på nytt.',
  'fabric.linking.unlink_account': 'Fjern kobling fra konto',
  'fabric.linking.updated_by': 'Endret av {context}',
  'fabric.linking.view': 'Vis',
};
